import React, {memo, useState} from 'react'

/* Components */
import ProductCard from './ProductCard'
import CampaignWidgetSkeleton from './CampaignWidgetSkeleton'

/* Utils */
import DataSet from '../../../../utils/DataSet'
import {yieldToMain} from '../../../../utils/performance'

/* Constants */
import {DAVINCI_EVENT_NAMES} from '../../../../modules/analytics/davinci/davinciConstants'

/* Styles */
import s from './product-carousel.scss'

const CampaignWidget = memo((props) => {
  const {data, dispatch, sponsoredCampaignWidget = false} = props
  const [currentIndex, setCurrentIndex] = useState(0)
  const [translateWidth, setTranslateWidth] = useState(0)
  const productList = data?.items || []
  const {redirectUrl, backgroundImage, title, subTitle, placementId} = data

  const ITEM_WIDTH = 367
  const OFFSET_WIDTH = 314
  const isSponsoredProductWithTitles = sponsoredCampaignWidget && (title || subTitle);

  const swipeRight = async(e) => {
    e.preventDefault()
    if (currentIndex === productList.length - 1) {
      setCurrentIndex(0)
      setTranslateWidth(0)
      return
    } else {
      setCurrentIndex(currentIndex + 1)
    }
    await yieldToMain()
    if (currentIndex === 0) {
      setTranslateWidth(-OFFSET_WIDTH)
    } else if (currentIndex === productList.length - 2) {
      setTranslateWidth(translateWidth - OFFSET_WIDTH)
    } else {
      setTranslateWidth(translateWidth - ITEM_WIDTH)
    }
  }

  const swipeLeft = async(e) => {
    e.preventDefault()
    if (currentIndex === 0) {
      return
    }
    await yieldToMain()
    setCurrentIndex(currentIndex - 1)

    if (currentIndex === 1) {
      setTranslateWidth(0)
    } else if (currentIndex === productList.length - 1) {
      setTranslateWidth(translateWidth + OFFSET_WIDTH)
    } else {
      setTranslateWidth(translateWidth + ITEM_WIDTH)
    }
  }

  const handleCampaignWidgetClick = async() => {
    await yieldToMain()
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.COMPONENT_CLICK, {
      componentType: 'Image',
      contentId: '',
      contentGroupId: data?.contentGroupId,
      url: redirectUrl,
      page_type: window?.hepsiBus?.parsers?.getPageType()
    })
  }

  if (productList?.length === 0) {
    return <CampaignWidgetSkeleton/>
  }

  return (
    <div
      data-hbus={DataSet.createComponentViewDataForDavinci({
        pageType: 'home',
        pageValue: '',
        componentType: 'Image',
        contentId: '',
        contentGroupId: data?.contentGroupId,
        url: redirectUrl
      })}
      data-test-id={`${props?.type}`}
      className={`${s.campaignWidget} ${isSponsoredProductWithTitles ? s.sponsoredCampaignWidget : ''}`}
      style={{
        backgroundImage: `url('${backgroundImage ?? ''}')`
      }}>
      {
        isSponsoredProductWithTitles ? (
          <div className={s.sponsoredWidgetHeader}>
            <h2 className={s.sponsoredWidgetTitle} data-test-id={`${props?.type}-title`}>{title ?? ''}</h2>
            <h3 className={s.sponsoredWidgetSubTitle} data-test-id={`${props?.type}-subTitle`}>{subTitle ?? ''}</h3>
          </div>
        ) : 
          !sponsoredCampaignWidget && <a className={s.link} title='campaign-widget' href={redirectUrl} target='_blank' onClick={(e) => handleCampaignWidgetClick(e)}></a>
      }
      <div className={s.cardWrapper}>
        {currentIndex !== 0 && (
          <div className={s.arrowWrapperLeft}>
            <i
              onClick={(e) => swipeLeft(e)}
              className={s.iconLeft}
              data-test-id={`${props?.type}-left-arrow`}
              role='button' tabIndex='0' aria-label='Önceki ürün'/>
          </div>
        )}
        <div className={s.cards} style={{transform: `translateX(${translateWidth}px)`}}>
          {productList?.map((product, index) => (
            <div
              data-test-id={`${props?.type}-campaign-card-${index}`}
              aria-hidden={index === currentIndex ? false : true}
              className={s.campaignCard}
              style={{transform: `translateX(${index * ITEM_WIDTH + 16}px)`}}
              key={index}>
              <ProductCard
                productData={product}
                dispatch={dispatch}
                index={index}
                contentGroupId={data?.contentGroupId}
                isBot={props?.isBot}
                placementId={placementId}
                sponsoredWidgetTitle={title}
                sponsoredCampaignWidget={sponsoredCampaignWidget} />
            </div>
          ))}
        </div>
        <div className={s.arrowWrapperRight}>
          <i
            onClick={(e) => swipeRight(e)}
            className={s.iconRight}
            data-test-id={`${props?.type}-right-arrow`}
            role='button' tabIndex='0' aria-label='Sonraki ürün'/>
        </div>
      </div>
    </div>
  )
})

export default CampaignWidget
